import { render } from "./ActivityDropdown.vue?vue&type=template&id=4021874a&scoped=true"
import script from "./ActivityDropdown.vue?vue&type=script&lang=js"
export * from "./ActivityDropdown.vue?vue&type=script&lang=js"

import "./ActivityDropdown.vue?vue&type=style&index=0&id=4021874a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4021874a"]])

export default __exports__